import React, { useState, useEffect } from 'react';
import {
  FaGasPump, FaUsers, FaTruck, FaExchangeAlt,
  FaArrowDown, FaArrowUp, FaClock, FaCheckCircle,
  FaDotCircle
} from 'react-icons/fa';
import StatsCard from '../components/StatsCard';
import '../styles/Dashboard.css';

const recentTransactions = [
  { id: 1, type: 'OUT', aircraft: 'PZ-TAB', pilot: 'Carlos Hew', amount: '120 Gal', tanker: 'Tanker A', time: '08:14', date: 'Today', status: 'completed' },
  { id: 2, type: 'IN',  aircraft: null, vendor: 'Vendor 1', amount: '800 Gal', tanker: 'Tanker B', time: '07:45', date: 'Today', status: 'completed' },
  { id: 3, type: 'OUT', aircraft: 'PZ-SUR', pilot: 'Mark Lie', amount: '95 Gal', tanker: 'Tanker A', time: '07:10', date: 'Today', status: 'completed' },
  { id: 4, type: 'OUT', aircraft: 'PZ-DBN', pilot: 'Sam Jones', amount: '210 Gal', tanker: 'Tanker C', time: '06:55', date: 'Today', status: 'completed' },
  { id: 5, type: 'IN',  aircraft: null, vendor: 'Vendor 2', amount: '500 Gal', tanker: 'Tanker C', time: '18:30', date: 'Yesterday', status: 'completed' },
];

const tankerStatus = [
  { id: 1, name: 'Tanker A', level: 72, capacity: 1000, unit: 'Gal', status: 'available', fuelType: 'JET A-1' },
  { id: 2, name: 'Tanker B', level: 45, capacity: 1000, unit: 'Gal', status: 'in-use',   fuelType: 'JET A-1' },
  { id: 3, name: 'Tanker C', level: 18, capacity: 800,  unit: 'Gal', status: 'available', fuelType: 'AVGAS 100LL' },
];

function FuelBar({ level, color }) {
  const bar = level < 20 ? '#ef4444' : level < 40 ? '#f59e0b' : '#22c55e';
  return (
    <div className="fuel-bar-track">
      <div className="fuel-bar-fill" style={{ width: `${level}%`, background: bar }} />
    </div>
  );
}

export default function Dashboard() {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Dashboard</h1>
          <p className="page-subtitle">Real-time overview of UAS fuel operations</p>
        </div>
        <div className="header-time">
          <FaClock className="time-icon" />
          <span>{time.toLocaleString()}</span>
        </div>
      </div>

      {/* Stats Row */}
      <div className="stats-row">
        <StatsCard icon={<FaGasPump />} label="Total fuel dispensed today" value="1,240 Gal" sub="+12% vs yesterday" />
        <StatsCard icon={<FaExchangeAlt />} label="Transactions today" value="14" sub="9 OUT · 5 IN" color="#f5af18" />
        <StatsCard icon={<FaTruck />} label="Active tankers" value="3" sub="2 available · 1 in use" color="#8b5cf6" />
        <StatsCard icon={<FaUsers />} label="Active fuelers" value="6" color="#35c068" />
      </div>

      <div className="dashboard-grid">
        {/* Tanker Status */}
        <div className="dash-card">
          <div className="dash-card-header">
            <h3>Tanker fuel levels</h3>
            <span className="dash-card-badge">Live</span>
          </div>
          <div className="tanker-list">
            {tankerStatus.map(t => (
              <div key={t.id} className="tanker-row">
                <div className="tanker-row-top">
                  <div className="tanker-name">
                    <FaTruck className="tanker-icon" />
                    <span>{t.name}</span>
                    <span className="fuel-type-badge">{t.fuelType}</span>
                  </div>
                  <div className={`tanker-status-badge ${t.status}`}>
                    <FaDotCircle />
                    {t.status === 'in-use' ? 'In Use' : 'Available'}
                  </div>
                </div>
                <FuelBar level={t.level} />
                <div className="tanker-level-text">
                  <span className={t.level < 20 ? 'level-low' : ''}>{t.level}%</span>
                  <span className="level-gal">{Math.round(t.capacity * t.level / 100)} / {t.capacity} {t.unit}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Recent Transactions */}
        <div className="dash-card">
          <div className="dash-card-header">
            <h3>Recent transactions</h3>
          </div>
          <div className="txn-list">
            {recentTransactions.map(tx => (
              <div key={tx.id} className="txn-row">
                <div className={`txn-type-badge ${tx.type === 'OUT' ? 'out' : 'in'}`}>
                  {tx.type === 'OUT' ? <FaArrowUp /> : <FaArrowDown />}
                  {tx.type}
                </div>
                <div className="txn-info">
                  <div className="txn-main">
                    {tx.type === 'OUT' ? `${tx.aircraft} — ${tx.pilot}` : `Vendor: ${tx.vendor}`}
                  </div>
                  <div className="txn-sub">{tx.tanker} · {tx.time}, {tx.date}</div>
                </div>
                <div className="txn-amount">{tx.amount}</div>
                <FaCheckCircle className="txn-check" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
